var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEstate360 = function SvgEstate360(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#04F",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M2.8 12a9.2 9.2 0 1 0 18.4 0 9.2 9.2 0 0 0-18.4 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#04F",
    d: "M18.44 15.718a7.437 7.437 0 0 1-11.966 1.258l.608-.548a6.618 6.618 0 0 0 10.65-1.119zM12 4.564a7.435 7.435 0 0 1 7.072 9.734l-.778-.253A6.618 6.618 0 0 0 12 5.382zM5.604 15.792A7.436 7.436 0 0 1 10.37 4.745l.18.798a6.618 6.618 0 0 0-4.243 9.832z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#04F",
    d: "M16.577 10.33a4.87 4.87 0 0 0-6.247-2.907l.264.723a4.1 4.1 0 0 1 5.26 2.448zM7.78 9.564a4.87 4.87 0 0 0 1.784 6.655l.385-.667A4.104 4.104 0 0 1 8.448 9.95zM11.624 16.857a4.873 4.873 0 0 0 5.233-4.481l-.767-.06a4.1 4.1 0 0 1-4.406 3.774z"
  })));
};
export default SvgEstate360;